import React, { Suspense } from 'react';
import {
  Switch,
  Route,
} from "react-router-dom";
import { Routes } from './configs/routes';
import "./App.scss";
import registerComponent from 'orion-web/utils/registerComponents';
import OrionWebComponents from './components/OrionWeb';

registerComponent(OrionWebComponents);

const App: React.FunctionComponent = () => {

  const renderRoutes = () => {
    return Routes.map((route, routeIndex) => (
      <Route
        path={route.path}
        exact={route.exact}
        component={route.component}
        key={`app_route_${routeIndex}`}
      />
    ));
  }

  return (
    <Suspense fallback={<div></div>}>
      <Switch>
        {renderRoutes()}
      </Switch>
    </Suspense>
  );
}

export default App;
